import { createRivalRouteMetric, createWebVitalsMetric } from '@funtech-int/yango-shared';

export const routesMetric = createRivalRouteMetric({
    render: 'SLI.Screen.Show',
});

export const webVitalsMetric = createWebVitalsMetric({
    fcp: 'SLI.Web.Start',
});
